import { ValuesModel } from './values.model';

export class FeesGeneralModel {
  order_value: ValuesModel | null = null;
  phonetics_amount: ValuesModel | null = null;
  service_fee: ValuesModel | null = null;
  energy_cost_surcharge: ValuesModel | null = null;
  cash_discount_refund: ValuesModel | null = null;
  zpa: ValuesModel | null = null;
  cooling_fee: ValuesModel | null = null;
  ksa: ValuesModel | null = null;
  lb: ValuesModel | null = null;
  mlb: ValuesModel | null = null;
  fees_pzn: ValuesModel | null = null;
  sum = 0;
  visible = false;

  readonly sort = [
    'order_value', 'phonetics_amount', 'service_fee', 'energy_cost_surcharge',
    'cash_discount_refund', 'zpa', 'cooling_fee', 'ksa', 'lb', 'mlb', 'fees_pzn'
  ] as const;

  private readonly labelMap: Record<string, string> = {
    order_value: 'Auftragswert',
    phonetics_amount: 'Phonetikbeitrag',
    service_fee: 'Servicegebühr',
    energy_cost_surcharge: 'Energiekostenzuschlag (EKZ)',
    cash_discount_refund: 'Skontorückbelastung',
    zpa: 'Zielpackungsausgleich (ZPA)',
    cooling_fee: 'Kühlartikelgebühr',
    ksa: 'Konditionssicherungsausgleich (KSA)',
    lb: 'Leistungsbeitrag (LB)',
    mlb: 'Mindestlohnbeitrag (MLB)',
    fees_pzn: 'Gebühren PZN (BTM, Zytostatika, Sonderbote, Covid)'
  };

  constructor(obj?: Record<string, any>) {
    for (const [key, label] of Object.entries(this.labelMap)) {
      (this as any)[key] = obj?.[key]
        ? new ValuesModel({ value: obj[key], label })
        : null;
    }
    this.sum = obj?.['sum'] ?? 0;
    this.visible = obj?.['visible'] ?? false;
  }
}

export class FeeReturnsModel {
  deduction_order_error: ValuesModel | null = null;
  deduction_returns: ValuesModel | null = null;
  service_fee_merchandise_credit: ValuesModel | null = null;
  service_fee_returns: ValuesModel | null = null;
  deduction_hp: ValuesModel | null = null;
  sum = 0;
  visible = false;

  readonly sort = [
    'deduction_order_error', 'deduction_returns',
    'service_fee_merchandise_credit', 'service_fee_returns', 'deduction_hp'
  ] as const;

  private readonly labelMap: Record<string, string> = {
    deduction_order_error: 'Fixabschlag Bestellfehler',
    deduction_returns: 'Fixabschlag Warenrücknahme',
    service_fee_merchandise_credit: 'Bearbeitungsgebühr Warengutschriften',
    service_fee_returns: 'Bearbeitungsgebühr Warenrücknahme',
    deduction_hp: 'Fixabschlag Hochpreis'
  };

  constructor(obj?: Record<string, any>) {
    for (const [key, label] of Object.entries(this.labelMap)) {
      (this as any)[key] = obj?.[key]
        ? new ValuesModel({ value: obj[key], label })
        : null;
    }
    this.sum = obj?.['sum'] ?? 0;
    this.visible = obj?.['visible'] ?? false;
  }
}
